import useUiPreferenceCache from "@apps/use-ui-preference-cache/use-ui-preference-cache";
import { currentUserVar } from "@cache/cache";
import InfoTooltip from "@components/tooltip/info-tooltip";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";
import { classNames } from "@helpers/css";

import ProfilePrivateNotes from "./profile-private-notes";

const SidebarPrivateNotes = ({
  profileId,
  subjectName,
}: {
  profileId: number;
  subjectName?: string;
}) => {
  const { uiPreferenceCache, saveUiPreference } = useUiPreferenceCache();
  const currentUser = currentUserVar();
  const privateNotesCalloutAcknowledged =
    uiPreferenceCache.privateNotesCalloutAcknowledged;
  const explanation =
    profileId === currentUser.id
      ? "These notes are available in the sidebar within your profile, as well as any 1:1 meetings you have with your manager. Any notes you add here will be available in both places."
      : `These notes are available in the sidebar within${subjectName ? ` ${subjectName}'s` : " this person's"} profile, as well as any 1:1 meetings you have with them. Any notes you add here will be available in both places.`;
  return (
    <div>
      <div className="flex text-gray-500 font-medium text-xs justify-between items-center gap-2 px-6 pt-4">
        <div className="flex items-center gap-2">
          <TopicflowIcon type="eyeOff" className="h-4 w-4" />
          Only visible to you
        </div>
        <InfoTooltip text={explanation} />
      </div>
      {privateNotesCalloutAcknowledged ? (
        <div>
          <ProfilePrivateNotes
            profileId={profileId}
            disabled={!privateNotesCalloutAcknowledged}
            className={classNames(
              "px-6 py-4 flex-1 border-0",
              privateNotesCalloutAcknowledged
                ? "min-h-[calc(100vh-240px)]"
                : "h-16",
            )}
          />
        </div>
      ) : (
        <div className="mt-4 mx-6 mb-4 flex gap-3 items-start rounded-md bg-gray-100 p-4">
          <TopicflowIcon
            type="info"
            className="h-4 w-4 mt-0.5 shrink-0 text-gray-500"
          />
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <p className="text-sm font-semibold text-gray-800">
                This notes area is only visible to you
              </p>
              <p className="text-sm text-gray-600">{explanation}</p>
            </div>
            <button
              className="self-start rounded-md border border-gray-200 bg-white px-2 py-0.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
              onClick={() =>
                saveUiPreference({ privateNotesCalloutAcknowledged: true })
              }
            >
              Acknowledge and Dismiss
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SidebarPrivateNotes;
